<template>
  <div>
    <a
      class="nav-link nav-link-search iconLogo iconLogoDisabled"
      role="button"
      tabindex="-1"
      aria-disabled="true"
      @click.prevent
    >
      <feather-icon
        icon="SearchIcon"
        size="21"
      />
      <label class="mb-0 d-none d-md-inline-block ml-75">Search for anything</label>
    </a>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/bootstrap-extended/include";
@import "~@core/scss/base/components/variables-dark";

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
p {
  margin: 0;
}

/* .app-auto-suggest {
  position: relative;
}

.auto-suggest-suggestions-list {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  border-radius: 6px;
  position: absolute;
  top: calc(100% + 1rem);
  background-color: white;
  width: 100%;
} */

.suggestion-group-title {
  font-weight: 500;
  padding: 0.75rem 1rem 0.25rem;
}

.suggestion-group-suggestion {
  padding: 0.75rem 1rem;
}

.suggestion-current-selected {
  background-color: $body-bg;

  .dark-layout & {
    background-color: $theme-dark-body-bg;
  }
}

.iconLogo{
  background-color: #52DCAB33;
  border-radius: 10px;
  padding: 1rem 5rem 1rem 1rem;
}

.iconLogoDisabled {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}

.iconLogo label {
  color: #20306C;
  font-weight: 400;
  font-size: 1rem;
}
</style>
